import React from "react";
import GeneralStrings from "../../../strings/GeneralStrings.json";
import termsConditions from "../../../assets/pdfs/terms-conditions.pdf";
import { Field } from "formik";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";

const TermsStep = () => {
  const TERMS_STEP_STRINGS = GeneralStrings.ENROLL.FORM_LABELS.TERMS_STEP;
  return (
    <div className="step">
      <h4 className="step-header">{TERMS_STEP_STRINGS.HEADER}</h4>
      <div className="terms-container">
        <div className="form-group">
          <a href={termsConditions} target="_blank" rel="noreferrer">
            {TERMS_STEP_STRINGS.TERMS_AND_CONDITIONS}
          </a>
        </div>
        <FormGroup name="termsAndConditionsAcceptance" className="form-group">
          <Field
            required
            type="checkbox"
            as={FormControlLabel}
            control={<Checkbox />}
            name="termsAndConditionsAcceptance"
            label="I have read and agree to the terms and conditions"
            value="accepted"
          />
        </FormGroup>
      </div>
    </div>
  );
};

export default TermsStep;
